import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Language {
	language: string;
	code: string;
	icon: string;
}

@Injectable({
	providedIn: 'root'
})
export class LayoutService {
	public config = {
		settings: {
			layout: 'Dubai',
			layout_type: 'ltr',
			layout_version: 'light-only',
			sidebar_type: 'default-sidebar',
			icon: 'stroke-svg'
		},
		color: {
			primary_color: '#5a31f4',
			secondary_color: '#f73164'
		}
	};

	public selectedLanguage: any = {
		language: 'Français',
		code: 'fr',
		icon: 'fr'
	};

	public defaultLanguage: any = {
		language: 'Français',
		code: 'fr',
		icon: 'fr'
	};

	constructor(private translateService: TranslateService) {
		this.initLanguage();
		this.initStyle();
	}

	initStyle() {
		document.documentElement.style.setProperty('--theme-deafult', this.config.color.primary_color);
		document.documentElement.style.setProperty('--theme-secondary', this.config.color.secondary_color);
	}

	initLanguage() {
		const currentLang = this.getCurrentLanguage();
		this.changeLanguage(currentLang);
	}

	changeLanguage(lang: Language) {
		// save language in local storage
		localStorage.setItem('lang', JSON.stringify(lang));
		// use language
		this.translateService.use(lang.code);
		// change direction
		this.config.settings.layout_type = lang?.code === 'ar' ? 'rtl' : 'ltr';
		document.getElementsByTagName('html')[0].setAttribute('dir', this.config.settings.layout_type);
	}

	getCurrentLanguage(): Language {
		const currentLang = localStorage.getItem('lang');
		if (currentLang && currentLang !== 'undefined') {
			this.defaultLanguage = JSON.parse(currentLang);
		}
		return this.defaultLanguage;
	}
}
